import { RefreshCw, X, Zap } from 'lucide-react';
import { usePWAUpdate } from '@/hooks/usePWAUpdate';

export function PWAUpdatePrompt() {
  const { needRefresh, applyUpdate, dismiss } = usePWAUpdate();

  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-24 md:bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-[110] bg-gradient-to-br from-[hsl(var(--premium-surface))] to-[hsl(var(--premium-bg))] border border-[hsl(var(--premium-border))] rounded-xl p-4 shadow-2xl animate-fade-in">
      <button
        onClick={dismiss}
        className="absolute top-3 right-3 text-[hsl(var(--text-muted))] hover:text-white transition-colors"
        aria-label="Dismiss update prompt"
      >
        <X className="h-4 w-4" />
      </button>

      <div className="flex items-center gap-3 pr-6">
        <div className="p-2 bg-primary/15 rounded-lg shrink-0">
          <Zap className="h-4 w-4 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white font-semibold text-sm">Update Available</p>
          <p className="text-[hsl(var(--text-secondary))] text-xs mt-0.5 leading-relaxed">
            New features are ready. Tap to refresh.
          </p>
        </div>
        <button
          onClick={applyUpdate}
          className="flex items-center gap-1.5 bg-primary hover:bg-primary/90 text-primary-foreground text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors shrink-0"
        >
          <RefreshCw className="h-3.5 w-3.5" />
          Refresh
        </button>
      </div>
    </div>
  );
}
